export default {
    getAllSDM17DECs: () => {
        return {
            url: '/fhepool/SDM17DECs',
            method: 'GET'
        };
    },
    getSDM17DECDetails: SDM17DECId => {
        return {
            url: '/fhepool/SDM17DECs/:SDM17DECId',
            method: 'GET',
            route_params: {
                SDM17DECId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17DEC/api.js